import { useCallback, useState } from 'react';

/**
 * Manages the visible/dismissed state for ChallengeCelebrationModal.
 * Export this from the component barrel so the orchestrator can pair it
 * with conditional mounting logic without reaching into the component's internals.
 */
export const useChallengeCelebrationModal = () => {
  const [isVisible, setIsVisible] = useState(true);

  const dismiss = useCallback(() => {
    setIsVisible(false);
  }, []);

  return { isVisible, dismiss };
};
